import { combineReducers } from 'redux';

import screenReducer from './reducers/screenReducer';
import gameDetailsReducer from './reducers/gameDetailsReducer';
import curriculumReducer from './reducers/curriculumReducer';
import evidenceReducer from './reducers/evidenceReducer';
import inferenceReducer from './reducers/inferenceReducer';
import mapReducer from './reducers/mapReducer';
import submittedAnswersReducer from './reducers/submittedAnswersReducer';
import progressReducer from './reducers/progressReducer';
import onboardingReducer from './reducers/onboardingReducer';
import gameHeaderReducer from './reducers/gameHeaderReducer';
import saveDataReducer from './reducers/saveDataReducer';
// keeping the reducer collection as a separate exported object enables us
// to do some light test automation on every reducer.
// see ./reducers/__tests__/reducerRejections.test.js
// for more details.
export const reducerCollection = {
  screen: screenReducer,
  gameDetails: gameDetailsReducer,
  curriculum: curriculumReducer,
  evidence: evidenceReducer,
  inference: inferenceReducer,
  map: mapReducer,
  submittedAnswers: submittedAnswersReducer,
  progress: progressReducer,
  onboarding: onboardingReducer,
  gameHeader: gameHeaderReducer,
  saveData: saveDataReducer,
};

const reducers = combineReducers(reducerCollection);

export default reducers;
